<template>
    <div>
        <div class="inner-header-bg">
            <innerheader />
        </div>
        <dashboard />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheader from "@/components/innerheader/innerheader.vue";
import dashboard from "@/components/dashboard/dashboard.vue";

export default {
  name: 'dashbord',
  components: {
     innerheader,
     dashboard
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/dashboard.scss';
</style>